var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllcard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 87,
    viewBox: "0 0 67 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0357 44.5587C38.0357 47.0118 36.6027 49 34.1496 49H24.9896C22.5365 49 21.1035 47.0118 21.1035 44.5587",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0072 39.0072C40.2334 39.0072 41.2279 40.2501 41.2279 41.783C41.2279 43.3159 40.2334 44.5587 39.0072 44.5587H20.132C18.9058 44.5587 17.9114 43.3159 17.9114 41.783C17.9114 40.2501 18.9058 39.0072 20.132 39.0072",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5624 39.0072H28.1339C27.9868 39.0073 27.8458 39.0657 27.7418 39.1696L25.8799 41.0314C25.8541 41.0572 25.8235 41.0777 25.7898 41.0917C25.7561 41.1056 25.72 41.1128 25.6835 41.1128C25.6471 41.1128 25.6109 41.1056 25.5772 41.0917C25.5435 41.0777 25.5129 41.0572 25.4872 41.0314L23.6253 39.1696C23.5213 39.0657 23.3803 39.0073 23.2332 39.0072H19.5768C19.1351 39.0072 18.7115 38.8317 18.3992 38.5194C18.0868 38.2071 17.9114 37.7834 17.9114 37.3417C17.9114 36.9 18.0868 36.4764 18.3992 36.1641C18.7115 35.8517 19.1351 35.6763 19.5768 35.6763H39.5624C40.0041 35.6763 40.4277 35.8517 40.7401 36.1641C41.0524 36.4764 41.2279 36.9 41.2279 37.3417C41.2279 37.7834 41.0524 38.2071 40.7401 38.5194C40.4277 38.8317 40.0041 39.0072 39.5624 39.0072Z",
    fill: "#FCC436",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1318 34.8435V34.8283C20.1318 31.0116 23.2546 29.0144 27.0713 29.0144H32.0677C35.8843 29.0144 39.0071 31.0268 39.0071 34.8435V34.8283",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4148 23.4629L32.9311 27.902",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4556 49H43.1229C43.6831 48.9999 44.2226 48.7882 44.6333 48.4071C45.044 48.0261 45.2954 47.5039 45.3373 46.9452L47.8202 23.4629",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.228 23.4629L42.3383 19.0217L45.5999 17.9113",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2351 23.4629H49",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.182 84.7139L31.0675 78.0539H31.927L33.799 84.7139H33.2185L31.4905 78.4364H31.4995L29.7625 84.7139H29.182ZM30.046 82.8644V82.3739H32.9485V82.8644H30.046ZM35.5813 77.6804V84.7139H35.0323V77.6804H35.5813ZM37.7522 77.6804V84.7139H37.2032V77.6804H37.7522Z",
    fill: "#797D86"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3344,
    y: 1.61464,
    width: 64.051,
    height: 64.051,
    rx: 32.0255,
    stroke: "#FCC436",
    strokeWidth: 2.66879
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllcard);
export default __webpack_public_path__ + "static/media/allcard.9ec7d1eb3c8941412224bd6c5f7195c0.svg";
export { ForwardRef as ReactComponent };